export default {
  data: function data() {
    return {
      isFilterNotFound: false
    };
  },
  methods: {
    onSearch: function onSearch() {
      var treeRef = this.$refs.treeRef,
          searchInputValue = this.searchInputValue;

      if (treeRef) {
        var filterNodes = treeRef.filter(searchInputValue);
        this.isFilterNotFound = searchInputValue && filterNodes.length === 0;
      }
    },
    setSearchInputValue: function setSearchInputValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var changeVisible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var onSearch = this.onSearch,
          innerVisible = this.innerVisible,
          setInnerVisible = this.setInnerVisible,
          searchInputValue = this.searchInputValue,
          forceUpdateTriggerAlign = this.forceUpdateTriggerAlign;
      this.searchInputValue = value;

      if (!innerVisible && changeVisible) {
        setInnerVisible(true);
      }

      onSearch(value);

      if (trigger) {
        this.$emit('search', value);
      }

      if (searchInputValue !== value) {
        forceUpdateTriggerAlign();
      }
    },
    clearSearchInputValue: function clearSearchInputValue() {
      var checkAutoClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var autoClearSearchValue = this.autoClearSearchValue,
          setSearchInputValue = this.setSearchInputValue;

      if (checkAutoClear && !autoClearSearchValue) {
        return;
      }

      setSearchInputValue('', true, false);
    },
    renderNotFound: function renderNotFound() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          isFilterNotFound = this.isFilterNotFound,
          notFoundContent = this.notFoundContent;
      return isFilterNotFound ? h("span", {
        "class": "".concat(prefixCls, "-not-found")
      }, [notFoundContent]) : null;
    }
  }
};